import { JsonObject, JsonProperty } from 'json2typescript';

import { FatcaInterface, FatcaTypeEntity } from '../../../core';
import { FatcaManager } from './fatca-manager';
import { FatcaTypeEntityAdapter } from '../../client/helpers/serializer/adapters/fatca-type-entity.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';
import { Tax } from './tax';

@JsonObject('Fatca')
export class Fatca implements FatcaInterface {
    @JsonProperty('TypeOfEntity', FatcaTypeEntityAdapter, true)
    private _typeOfEntity: FatcaTypeEntity = undefined;

    @JsonProperty('GIIN', StringAdapter, true)
    private _giin: string = undefined;

    @JsonProperty('FatcaManager', [FatcaManager], true)
    private _managers: FatcaManager[] = undefined;

    @JsonProperty('StockExhange', StringAdapter, true)
    private _nameMarket: string = undefined;

    @JsonProperty('SharesCompany', StringAdapter, true)
    private _nameSociety: string = undefined;

    @JsonProperty('TaxResidence', Tax, true)
    private _tax: Tax = undefined;

    get typeOfEntity(): FatcaTypeEntity {
        return this._typeOfEntity;
    }

    set typeOfEntity(value: FatcaTypeEntity) {
        this._typeOfEntity = value;

        this._giin = undefined;
        this._managers = [];
        this._nameMarket = undefined;
        this._nameSociety = undefined;
    }

    get giin(): string {
        return this._giin;
    }

    set giin(value: string) {
        this._giin = value;
    }

    get managers(): FatcaManager[] {
        if (!this._managers) {
            this._managers = [];
        }

        return this._managers;
    }

    addManager(value: FatcaManager) {
        if (!this.managers.find(it => it.id.value === value.id.value)) {
            this.managers.push(value);
        }
    }

    updateManager(value: FatcaManager) {
        this.managers.map((it, idx) => {
            if (it.id.value === value.id.value) {
                this.managers[idx] = value;
            }
        });
    }

    removeManager(value: FatcaManager) {
        this.managers.map((it, idx) => {
            if (it.id.value === value.id.value) {
                this.managers.splice(idx, 1);
            }
        });
    }

    get nameMarket(): string {
        return this._nameMarket;
    }

    set nameMarket(value: string) {
        this._nameMarket = value;
    }

    get nameSociety(): string {
        return this._nameSociety;
    }

    set nameSociety(value: string) {
        this._nameSociety = value;
    }

    get tax(): Tax {
        if (!this._tax) {
            this._tax = new Tax();
        }

        return this._tax;
    }

    isComplete(hasFullManagers = false): boolean {
        switch (this._typeOfEntity) {
            case FatcaTypeEntity.A1:
                return this.managers.length > 0
                    && (hasFullManagers ? !this.managers.some(manager => !manager.isComplete()) : !this.managers.some(manager => !manager.name));
            case FatcaTypeEntity.B:
                return !!this.giin;
            case FatcaTypeEntity.C:
                return !!this.nameMarket
                    && !!this.nameSociety;
            case FatcaTypeEntity.G:
                return this.managers.length > 0
                    && (hasFullManagers ? !this.managers.some(manager => !manager.isComplete()) : !this.managers.some(manager => !manager.name));
            default:
                return !!this.typeOfEntity;
        }
    }
}
